<template>
  <div id="bank-accounts-access-modal_saman" class="modal fade" role="dialog">
    <div class="modal-dialog" style="max-width: 700px">
      <!-- Modal content-->
      <div class="modal-content" id="bank-accounts-access-modal-content">
        <div class="modal-header">
          <h4 class="modal-title">
            {{ $t('label.manage_bank_accounts_access') }}
          </h4>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        <div class="modal-body">
          <form id="bank_accounts_access_form_saman">
            <kt-row class="mb-3">
              <!--Account Number-->
<!--              <kt-col lg="6" md="6" xs="12">-->
<!--                <label class="col-form-label" for="account_number">-->
<!--                  {{ $t('label.account_number') }}-->
<!--                </label>-->
<!--                <input-->
<!--                    dir="ltr"-->
<!--                    type="text"-->
<!--                    class="form-control en_num"-->
<!--                    id="account_number"-->
<!--                    name="account_number"-->
<!--                    v-model="bank_accounts_access.account_number"-->
<!--                >-->
<!--              </kt-col>-->
              <!--Status-->
              <kt-col lg="6" md="6" xs="12">
                <label class="col-form-label" for="status">
                  {{ $t('label.status') }}
                </label>
                <select id="status"
                        name="status"
                        class="form-control kt-selectpicker"
                        v-model="bank_accounts_access.status"
                >
                  <option :value="1" v-text="$t('label.pending')"></option>
                  <option :value="2" v-text="$t('label.active')"></option>
                  <option :value="3" v-text="$t('label.rejected')"></option>
                </select>
              </kt-col>
              <!--Username-->
              <kt-col lg="6" md="6" xs="12">
                <label class="col-form-label" for="username">
                  {{ $t('label.saman_username') }}
                </label>
                <input
                    dir="ltr"
                    type="text"
                    class="form-control en_num"
                    id="username"
                    name="username"
                    v-model="bank_accounts_access.username"
                >
              </kt-col>
              <!--Password-->
              <kt-col lg="6" md="6" xs="12">
                <label class="col-form-label" for="password">
                  {{ $t('label.password') }}
                </label>
                <input
                    dir="ltr"
                    type="password"
                    class="form-control en_num"
                    id="password"
                    name="password"
                    v-model="bank_accounts_access.password"
                >
              </kt-col>
                <kt-col lg="6" md="6" xs="12">
                    <label class="col-form-label" for="channel">
                        {{ $t('label.saman_channel') }}
                    </label>
                    <input
                        dir="ltr"
                        type="text"
                        class="form-control en_num"
                        id="channel"
                        name="channel"
                        v-model="bank_accounts_access.additional_credential.channel"
                    >
                </kt-col>
                <kt-col lg="6" md="6" xs="12">
                    <label class="col-form-label" for="secret_key">
                        {{ $t('label.saman_secret_key') }}
                    </label>
                    <input
                        dir="ltr"
                        type="password"
                        class="form-control en_num"
                        id="secret_key"
                        name="secret_key"
                        v-model="bank_accounts_access.additional_credential.secret_key"
                    >
                </kt-col>
                <kt-col lg="6" md="6" xs="12">
                    <label class="col-form-label" for="cif">
                        {{ $t('label.saman_cif') }}
                    </label>
                    <input
                        dir="ltr"
                        type="text"
                        class="form-control en_num"
                        id="cif"
                        name="cif"
                        v-model="bank_accounts_access.additional_credential.cif"
                    >
                </kt-col>
            </kt-row>
            <!--Button-->
            <kt-form-action class="mt-4">
              <kt-button
                  class="m-2 btn-wide"
                  size="lg"
                  variant="success"
                  type="button"
                  v-bind:wide="true"
                  id="store_bank_accounts_access_btn"
                  @click="storeBankAccountsAccess()"
              >
                {{ $t('btn.edit') }}
              </kt-button>
            </kt-form-action>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SamanBankAccountsAccessModal",
  props: {
    bank_accounts_access:{
      required: true
    }
  },
  methods: {
    storeBankAccountsAccess() {
      this.$emit('storeBankAccountsAccess', { ...this.bank_accounts_access, ...this.bank_accounts_access.additional_credential })
    }
  }
}
</script>

<style scoped>

</style>